let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eO6VH")).then(() => parcelRequire('9Refg'));